"use client";

import Context from "@/context/Context";
import AnnouncementBar from "@/components/Header/AnnouncementBar";
import HeaderDashboard from "@/components/Header/HeaderDashboard";
import PopupMobileMenu from "@/components/Header/PopUpMobileMenu";
import ComplaintBook from "@/components/ComplaintBook/ComplaintBook";
import Footer from "@/components/Footers/Footer";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const ComplaintBookClient = () => (
  <main className="page-wrapper rbt-dashboard-page">
    <Context>
      <div className="rbt-panel-wrapper">
        <AnnouncementBar />
        <HeaderDashboard display="d-none" />
        <PopupMobileMenu />
        <ComplaintBook />
        <Footer />
        <HomeChatSwitcher />
      </div>
    </Context>
  </main>
);

export default ComplaintBookClient;
